import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1a484888")
const _hoisted_1 = { class: "show-qr-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "medi-font"
}
const _hoisted_4 = {
  key: 1,
  class: "medi-font"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      alt: "",
      src: _ctx.url
    }, null, 8, _hoisted_2),
    (!_ctx.type)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "长按图片保存二维码"))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "长按图片识别二维码关注"))
  ]))
}